import * as types from 'model/actionTypes'
import { AnyAction } from 'redux'
import { DictT, PDetailsT } from 'model/types'

const initialState: DictT<PDetailsT> | null = null

export default function (state = initialState, action: AnyAction) {
  switch (action.type) {
    case types.RECEIVE_PROJECT_DETAILS:
      return action.pdetails
    case types.CLEAR:
    case types.LOGOUT:
      return initialState
    default:
      return state
  }
}
